import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1302Status: 'idle',
    startProcess1302Error: undefined as any,
    loadUserParamsProcess1302Status: 'idle',
    loadUserParamsProcess1302Error: undefined as any,

    process1302List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1302 = createAsyncThunk('process1302Slice/startProcess1302', async ({ process1302 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1302/`,
        prepareData(process1302),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1302Status } = getState().process1302Slice
        return startProcess1302Status !== 'pending'
    }
})

export const loadUserParamsProcess1302 = createAsyncThunk('process1302Slice/loadUserParamsProcess1302', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1302/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1302Status } = getState().process1302Slice
        return loadUserParamsProcess1302Status !== 'pending'
    }
})

const Process1302Slice = createSlice({
    name: 'process1302Slice',
    initialState,
    reducers: {
        resetstartProcess1302: (state) => {
            state.job = undefined
            state.startProcess1302Error = undefined
        },
        resetstartProcess1302Error: (state) => {
            state.startProcess1302Error = undefined
        },
        resetloadUserParamsProcess1302: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1302Error = undefined
        },
        resetloadUserParamsProcess1302Error: (state) => {
            state.loadUserParamsProcess1302Error = undefined
        },
        removeFromProcess1302ListById: (state, action) => {
            state.process1302List = state.process1302List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1302ListByIds: (state, action) => {
            state.process1302List = state.process1302List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1302List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1302Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1302List = []
            state.startProcess1302Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1302.pending, (state) => {
            state.startProcess1302Status = 'pending'
            state.startProcess1302Error = undefined
        })
        builder.addCase(startProcess1302.fulfilled, (state, action) => {
            state.startProcess1302Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1302.rejected, (state, action) => {
            state.startProcess1302Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1302Error = action.error.message
            } else {
                state.startProcess1302Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1302.pending, (state) => {
            state.loadUserParamsProcess1302Status = 'pending'
            state.loadUserParamsProcess1302Error = undefined
        })
        builder.addCase(loadUserParamsProcess1302.fulfilled, (state, action) => {
            state.loadUserParamsProcess1302Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1302.rejected, (state, action) => {
            state.loadUserParamsProcess1302Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1302Error = action.error.message
            } else {
                state.loadUserParamsProcess1302Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1302,
    resetstartProcess1302Error,
    resetloadUserParamsProcess1302,
    resetloadUserParamsProcess1302Error,
    removeFromProcess1302ListById,
    removeFromProcess1302ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1302Slice.actions
export default Process1302Slice.reducer
